import React from "react";
import { useSiteContent } from "../hooks/useSiteContent";
import SmoothScroll from "../components/SmoothScroll";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import BrandMarquee from "../components/BrandMarquee";
import Services from "../components/Services";
import AboutManifesto from "../components/AboutManifesto";
import Gallery from "../components/Gallery";
import Reviews from "../components/Reviews";
import QuoteForm from "../components/QuoteForm";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

export default function Landing() {
  const { content, loading } = useSiteContent();

  if (loading || !content) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="font-display text-primary-red text-3xl uppercase animate-pulse">JJ Truck Repair</div>
      </div>
    );
  }

  return (
    <div className="noise-overlay bg-[#050505]">
      <SmoothScroll />
      <Navbar content={content} />
      <Hero content={content} />
      <BrandMarquee />
      <Services content={content} />
      <AboutManifesto content={content} />
      <Gallery content={content} />
      <Reviews content={content} />
      <QuoteForm content={content} />
      <Contact content={content} />
      <Footer content={content} />
      <WhatsAppButton content={content} />
    </div>
  );
}
